module.exports = __webpack_public_path__ + "static/media/pg11.be4ea388.jpg";